import { FaEnvelope } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import {PiMicrosoftOutlookLogoFill} from "react-icons/pi";

const emailApps = [
    {
        name: "Gmail",
        icon: SiGmail,
        url: "https://mail.google.com",
        iconColor: "text-red-600"
    },
    {
        name: "Outlook",
        icon: PiMicrosoftOutlookLogoFill,
        url: "https://outlook.live.com",
        iconColor: "text-blue-600"
    },
    {
        name: "Email",
        icon: FaEnvelope,
        iconColor: "text-gray-600"
    }
];
interface Props {
    isSSOMode?: boolean;
}

export function StepThree({isSSOMode = false}: Props) {
    if (isSSOMode) {
        return (
            <div className="lg:pt-4 flex flex-col items-center justify-center">
                <div className="lg:max-w-lg text-center">
                    <h2 className="text-base font-semibold leading-7 text-primary">Gefeliciteerd 🎉</h2>
                    <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Je account is klaar</p>
                    <p className="mt-6 text-base leading-7 text-gray-600">
                        Je bent ingelogd en kunt direct aan de slag. Vernieuw de pagina als je niet automatisch wordt doorgestuurd.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="lg:pt-4 flex flex-col items-center justify-center">
            <div className="lg:max-w-lg text-center">
                <h2 className="text-base font-semibold leading-7 text-primary">Gefeliciteerd 🎉</h2>
                <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Wat nu?</p>

                <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">

                    <div>
                        <dt className="font-semibold text-gray-900">
                            Controleer je inbox en verifieer je e-mailadres.
                        </dt>
                        <dd className="mt-2">Pro tip: controleer ook je spambox</dd>
                        <div className="mt-4">
                            <p className="text-sm text-gray-500 mb-2">
                                Klik op een link hieronder om naar je inbox te gaan
                            </p>
                            <div className="flex items-center justify-center gap-6">
                                {emailApps.map((app) => {
                                    const Icon = app.icon;
                                    if (!app?.url ) {
                                        return (
                                            <div
                                                key={app.name}
                                                className="flex flex-col items-center justify-center gap-2 text-sm text-gray-500"
                                            >
                                                <Icon className={`h-8 w-8 ${app.iconColor}`} />
                                                <span>{app.name}</span>
                                            </div>
                                        );
                                    }
                                    return (
                                        <a
                                            key={app.name}
                                            href={app.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex flex-col items-center justify-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors underline decoration-gray-300 hover:decoration-gray-400"
                                        >
                                            <Icon className={`h-8 w-8 ${app.iconColor}`} />
                                            <span>{app.name}</span>
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </dl>
            </div>
        </div>
    )
}
